import { utcParse } from 'd3-time-format';
import { fromJS, List } from 'immutable';
import _ from 'lodash';
import { handleActions } from 'redux-actions';

import {
	SET_BEFORE_CHART,
	SET_INDEX_CHART,
	SET_INIT_CHART,
} from './constants';

import {
	SET_VPMES_DATA,
	SET_VPMNDX_DATA,
	SET_VPMNQ_DATA,
	SET_VPMSPX_DATA,
} from '../socket/constants';

const initialState = fromJS({
	id: '',
	initChartItems: {},
	symbol: '',
});

const parseData = (v: any) => {
	v.date = parseDate(v.date);
	v.time = parseInt(v.time, 10);
	v.open = +v.open;
	v.high = +v.high;
	v.low = +v.low;
	v.close = +v.close;
	v.percentile90 = +v.percentile90;
	v.percentile10 = +v.percentile10;
	return v;
};

const parseDate = utcParse('%Y-%m-%dT%H:%M:%S.%LZ');

const updateSocket = (state: any, action: any) => {
	const rState = state.toJS().initChartItems;
	const data = _.values(rState);
	const keys = _.keys(rState);
	let sym = action.payload.data.sym;

	const newLocal = sym.includes('&');
	if (!newLocal) {
		sym += '&interval=5second';
	}
	const ids: any[] = [];
	_.each(data, (items, index) => {
		if (items[sym] && items[sym].length > 0) {
			ids.push(keys[index]);
		}
	});
	if (ids.length > 0) {
		return state.setIn(['initChartItems', parseInt(ids[0], 10), sym],
			state.getIn(['initChartItems', parseInt(ids[0], 10), sym]).concat(List([parseData(action.payload.data)])));
	}
	return state;
};

export default handleActions({
	[SET_INIT_CHART]: (state: any, action: any) =>
		state.updateIn(['initChartItems', action.payload.id, action.payload.symbol], () => List(action.payload.init_chart_data.map((item: any) => item))),
	[SET_BEFORE_CHART]: (state: any, action: any) =>
		state.setIn(['initChartItems', action.payload.id, action.payload.symbol],
			List(action.payload.before_chart_data.map((item: any) => item)).concat(state.getIn(['initChartItems', action.payload.id, action.payload.symbol]))),
	[SET_INDEX_CHART]: (state: any, action: any) =>
		state
			.setIn(['initChartItems', action.payload.id, action.payload.symbol], List([]))
			.set('id', action.payload.id)
			.set('symbol', action.payload.symbol),
	[SET_VPMES_DATA]: (state: any, action: any) => updateSocket(state, action),
	[SET_VPMSPX_DATA]: (state: any, action: any) => updateSocket(state, action),
	[SET_VPMNQ_DATA]: (state: any, action: any) => updateSocket(state, action),
	[SET_VPMNDX_DATA]: (state: any, action: any) => updateSocket(state, action),
}, initialState);
